import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getRecommendedByName } from "./common";

const useStyles = makeStyles((theme) => ({
  typography: {
    fontWeight: 500,
    fontSize: 15,
  },
}));

export default function SimpleAccordionTable(props) {
  const classes = useStyles();
  const { proposalReferees, name } = props;
  const tableHeaders = [
    { label: "Referee", size: 300 },
    { label: "Recommended By", size: 200 },
  ];
  return (
    <Accordion style={{ margin: 5 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.typography}>{name}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeaders.map((th) => (
                <TableCell key={th.label} style={{ width: th.size }}>
                  {th.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {proposalReferees.map((pr) => (
              <TableRow key={pr.itemID}>
                <TableCell>{pr.name}</TableCell>
                <TableCell>{getRecommendedByName(pr.recommendedBy)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
}
